import { render, staticRenderFns } from "./HgFarmerTopHeader.vue?vue&type=template&id=624c755e&scoped=true"
import script from "./HgFarmerTopHeader.vue?vue&type=script&lang=js"
export * from "./HgFarmerTopHeader.vue?vue&type=script&lang=js"
import style0 from "./HgFarmerTopHeader.vue?vue&type=style&index=0&id=624c755e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624c755e",
  null
  
)

export default component.exports